export default __webpack_public_path__ + "ba925a7bc478fb024463d5dd5b95ef26.svg";